import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaPlane, FaUtensils } from 'react-icons/fa';
import searchIcon from '../../../assets/icons/search.svg';
import { NGODatePicker } from '../../../common';
import CustomSelect from '../../../common/CustomSelect';
const FilterBar = ({
  selectedDate,
  onDateChange,
  baseline,
  onBaselineChange,
  baselineOptions,
  searchTerm,
  onSearchChange,
  activeTab,
  onTabChange,
}) => {
  const { t } = useTranslation();
  return (
    <section className="monitor-card filter-card">
      <div className="filter-controls-row">
        <div className="filters-left">
          <NGODatePicker
            value={selectedDate}
            onChange={e => {
              if (e?.target?.value) {
                onDateChange(e.target.value);
              }
            }}
            dateFormat="MMMM d, yyyy"
            isclearable={false}
          />

          <div className="baseline-select-container">
            <CustomSelect
              options={baselineOptions.map(it => ({
                value: it.value,
                label: it.label,
              }))}
              defaultValue={baselineOptions.find(it => it.value === "baseline")}
              onChange={selectedOption =>
                onBaselineChange(selectedOption.value)
              }
            />
          </div>
          <div className="search-box-container">
            <div className="flexRow alignItemsCenter underline content-tabs">
              <span className="jusitfyContentCenter alignItemsCenter flexRow">
                <img
                  className="icon-size margBottom0"
                  alt={t('filters.searchText')}
                  src={searchIcon}
                />
                <input
                  className="search"
                  onChange={e => onSearchChange(e.target.value)}
                  type="search"
                  placeholder={t('filters.searchText')}
                  value={searchTerm}
                />
              </span>
            </div>
          </div>
        </div>

        <div className="filters-right">
          <div className="view-toggle-group">
            <button
              className={`toggle-btn ${activeTab === 'flight' ? 'active' : ''}`}
              onClick={() => onTabChange('flight')}
              type="button"
            >
              <FaPlane className="btn-icon" />
              <span>Flight Schedule</span>
            </button>
            <button
              className={`toggle-btn ${activeTab === 'catering' ? 'active' : ''}`}
              onClick={() => onTabChange('catering')}
              type="button"
            >
              <FaUtensils className="btn-icon" />
              <span>Catering Groups</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilterBar;
